import classNames from 'classnames';
import React from 'react';

import './OutboxDetailsItem.scss';

type Props = {
    label: React.ReactNode;
    additionalLabelInfo?: React.ReactNode;
    children: React.ReactNode[] | React.ReactNode;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export default ({ label, additionalLabelInfo, children, className, ...rest }: Props) => {
    return (
        <div className={classNames('approval-list-item-details__item', className)} {...rest}>
            <dt className="approval-list-item__item-label ">
                <span className="typography-caption">{label}</span>
                {additionalLabelInfo}
            </dt>
            <dd className="approval-list-item__item-value">{children}</dd>
        </div>
    );
};
